const normalize_id = (value) => String(value ?? "");

const has_entity_type = (entity_type_ids, entity_type_id) =>
  (entity_type_ids || []).some(
    (selected_id) => normalize_id(selected_id) === normalize_id(entity_type_id)
  );

export default {
  ensure_locked_profile_entity_type() {
    if (!this.is_profile_scope || !this.target_entity_type_id || !this.template_form) {
      return;
    }
    if (has_entity_type(this.template_form.entity_type_ids, this.target_entity_type_id)) {
      return;
    }
    this.template_form.entity_type_ids = [
      this.target_entity_type_id,
      ...(this.template_form.entity_type_ids || []),
    ];
  },
  is_locked_entity_type(entity_type_id) {
    if (!this.is_profile_scope || !this.target_entity_type_id) {
      return false;
    }
    return normalize_id(entity_type_id) === normalize_id(this.target_entity_type_id);
  },
  toggle_entity_type(entity_type_id) {
    if (!this.template_form || this.is_locked_entity_type(entity_type_id)) {
      return;
    }
    const current_ids = [...(this.template_form.entity_type_ids || [])];
    const next_ids = current_ids.some(
      (selected_id) => normalize_id(selected_id) === normalize_id(entity_type_id)
    )
      ? current_ids.filter(
          (selected_id) => normalize_id(selected_id) !== normalize_id(entity_type_id)
        )
      : [...current_ids, entity_type_id];
    this.template_form.entity_type_ids = next_ids;
    this.ensure_locked_profile_entity_type();
    this.refresh_question_options();
  },
  handle_template_save_mode_change() {
    this.ensure_locked_profile_entity_type();
    if (this.template_form?.save_as_template !== false) {
      return;
    }
    this.template_form.generation_mode = "manual";
    this.template_form.trigger_status_id = "";
  },
};
